export default __webpack_public_path__ + "static/media/Believer's Bands of the Aureate.7c639c12.jpg";